import { cn } from "@heroui/react";

interface CoolHeadingProps {
  children: React.ReactNode;
  className?: string;
  textShadowColor?: string;
  variant?: "subtle" | "bold" | "fixed";
}

export function BoldHeading({ children }) {
  return (
    <h1
      className={cn(
        `relative font-[Futura] text-[1.5rem] leading-[0.9] tracking-wider text-yellow sm:text-[2.4rem] md:text-nowrap md:text-[3.2rem]`
      )}
      style={{ textShadow: `-3px 2px 0 hsl(var(--heroui-pink))` }}
    >
      {children}
    </h1>
  );
}

export function CoolHeading(props: CoolHeadingProps) {
  const {
    children,
    className,
    textShadowColor = "hsl(var(--heroui-pink))",
    variant = "bold",
  } = props;

  let shadowSize = "";
  switch (variant) {
    case "fixed":
      shadowSize = "-1px 1px";
      break;
    case "subtle":
      shadowSize = "-2px 1px";
      break;
    case "bold":
      shadowSize = "-3px 2px";
      break;
  }

  return (
    <h1
      className={cn(
        `${className ? className : ""}`,
        `relative text-nowrap font-[Futura] leading-[0.9] tracking-wider text-yellow`
      )}
      style={{ textShadow: `${shadowSize} 0 ${textShadowColor}` }}
    >
      {children}
    </h1>
  );
}
